export const isNumber = value => !Number.isNaN(Number.parseFloat(value))

export const isToDecimalPlaces = decimalPlaces => num =>
  isNumber(num) && Number.parseFloat(Number(num).toFixed(decimalPlaces), 10) === Number(num)
